var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDashboardMyProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.784 0-1.953 27.786 1.953 27.787 15.544-3.805C94.963 46.718 100 38.055 100 28.216 100 12.633 87.367 0 71.784 0z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.232 12.672 43.716 31.12c1.357 13.264 11.9 23.807 25.164 25.164l2.904-.711V0c-9.84 0-18.502 5.037-23.552 12.672z",
    fill: "#FFE684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.776 12.448V31.12c13.864 0 25.104 11.24 25.104 25.104 0 13.864-11.24 25.104-25.104 25.104V100c24.177 0 43.776-19.6 43.776-43.776 0-24.177-19.6-43.776-43.776-43.776z",
    fill: "#ED5E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.672 56.224c0-13.864 11.24-25.104 25.104-25.104V12.448C19.599 12.448 0 32.048 0 56.224 0 80.401 19.6 100 43.776 100V81.328c-13.864 0-25.104-11.24-25.104-25.104z",
    fill: "#F991A3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboardMyProjects);
export default __webpack_public_path__ + "static/media/ic_dashboard_my_projects.5f41ef50d8be548d4035d4e1eb27518e.svg";
export { ForwardRef as ReactComponent };